import { ILoginState } from '../../types/state/ILoginState';
import AuthConstants, {
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    SELECT_CUSTOMER,
    BACK_TO_LOGIN,
    LOGOUT,
} from '../../constants/actions/auth.constants';
import { IAuthTokens, IAction } from '../../types';

export function login(
    state: ILoginState = { isLoading: false, tokens: undefined },
    { type, payload, error }: IAction,
) {
    switch (type) {
        case LOGIN:
        case AuthConstants.LOGIN_WITH_TOKEN:
        case AuthConstants.LOGIN_WITH_OAUTH:
            return { ...state, isLoading: true, tokens: undefined };
        case LOGIN_SUCCESS:
        case AuthConstants.LOGIN_WITH_TOKEN_SUCCESS:
        case AuthConstants.LOGIN_WITH_OAUTH_SUCCESS:
            return loginSuccess();
        case LOGIN_FAIL:
        case AuthConstants.LOGIN_WITH_TOKEN_FAIL:
        case AuthConstants.LOGIN_WITH_OAUTH_FAIL:
            return { ...state, error, isLoading: false };
        case SELECT_CUSTOMER:
        case BACK_TO_LOGIN:
            return { ...state, isLoading: false, tokens: undefined };
        case LOGOUT:
            return { isLoading: false, tokens: undefined };
        default:
            return state;
    }

    function loginSuccess() {
        const tokensValid = Array.isArray(payload) && payload.length > 1;
        const tokens = tokensValid ? (payload as IAuthTokens[]) : undefined;
        return { ...state, isLoading: false, tokens };
    }
}
